import type { Response } from '@src/utils/request'
import { fetcher } from '@src/utils/fetcher'

export async function getTaskList(body: any): Promise<Response> {
	return fetcher(`/sys/task/list`, 'POST', { body: body })
}
